(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (resourceRoot) => {
    if (!resourceRoot || resourceRoot.dataset.syPopularReady === 'true') return;

    const resourceCarousel = resourceRoot.querySelector('[data-sy-resource-carousel]');
    const resourceTrack = resourceCarousel && resourceCarousel.querySelector('[data-sy-resource-track]');
    const resourcePrev = resourceCarousel && resourceCarousel.querySelector('[data-sy-resource-prev]');
    const resourceNext = resourceCarousel && resourceCarousel.querySelector('[data-sy-resource-next]');
    const resourceDots = resourceCarousel && resourceCarousel.querySelector('[data-sy-resource-dots]');
    const resourceTabs = Array.from(resourceRoot.querySelectorAll('[data-sy-resource-tab]'));
    const resourcePanels = Array.from(resourceRoot.querySelectorAll('[data-sy-resource-panel]'));
    let resourceScrollFrame = null;

    if (!resourceTrack || !resourcePrev || !resourceNext || !resourceTabs.length || !resourcePanels.length) return;
    resourceRoot.dataset.syPopularReady = 'true';

    const activeResourcePanel = () => resourcePanels.find((panel) => panel.classList.contains('is-active')) || resourcePanels[0];

    const resourcePageCount = (panel) => {
      if (!panel || !resourceDots) return 0;
      return Math.max(1, Math.ceil((panel.scrollWidth - 1) / Math.max(panel.clientWidth, 1)));
    };

    const resourcePageIndex = (panel) => {
      if (!panel || !resourceDots) return 0;
      return Math.max(0, Math.min(resourcePageCount(panel) - 1, Math.round(panel.scrollLeft / Math.max(panel.clientWidth, 1))));
    };

    const updateResourceDots = () => {
      if (!resourceDots) return;
      const panel = activeResourcePanel();
      const count = resourcePageCount(panel);
      const activeIndex = resourcePageIndex(panel);

      if (resourceDots.children.length !== count) {
        resourceDots.replaceChildren();
        for (let index = 0; index < count; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sy-home-one__mobile-resource-dot';
          dot.dataset.syResourceDot = String(index);
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Show resource page ${index + 1}`);
          dot.addEventListener('click', () => {
            const currentPanel = activeResourcePanel();
            if (!currentPanel) return;
            currentPanel.scrollTo({
              left: index * currentPanel.clientWidth,
              behavior: reducedMotion.matches ? 'auto' : 'smooth',
            });
          });
          resourceDots.appendChild(dot);
        }
      }

      Array.from(resourceDots.children).forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        dot.tabIndex = isActive ? 0 : -1;
      });
    };

    const resourceStep = () => {
      const panel = activeResourcePanel();
      if (!panel) return resourceTrack.clientWidth;
      if (resourceDots) return Math.max(panel.clientWidth, 1);
      const card = panel.querySelector('.sy-home-one__resource-card');
      if (!card) return resourceTrack.clientWidth;
      const styles = window.getComputedStyle(panel);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateResourceControls = () => {
      const panel = activeResourcePanel();
      if (!panel) return;
      const canScroll = panel.scrollWidth > panel.clientWidth + 2;
      resourcePrev.hidden = !canScroll;
      resourceNext.hidden = !canScroll;
      updateResourceDots();
    };

    const setResourceTab = (nextKey, focusTab = false) => {
      resourceTabs.forEach((tab) => {
        const isActive = tab.dataset.syResourceTab === nextKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
        if (isActive && focusTab) tab.focus();
      });

      resourcePanels.forEach((panel) => {
        const isActive = panel.dataset.syResourcePanel === nextKey;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        if (isActive) panel.scrollTo({ left: 0, behavior: 'auto' });
      });

      window.requestAnimationFrame(updateResourceControls);
    };

    resourceTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setResourceTab(tab.dataset.syResourceTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % resourceTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + resourceTabs.length) % resourceTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = resourceTabs.length - 1;
        setResourceTab(resourceTabs[nextIndex].dataset.syResourceTab, true);
      });
    });

    resourcePanels.forEach((panel) => {
      panel.addEventListener('scroll', () => {
        if (resourceScrollFrame) window.cancelAnimationFrame(resourceScrollFrame);
        resourceScrollFrame = window.requestAnimationFrame(() => {
          updateResourceDots();
          updateResourceControls();
        });
      }, { passive: true });
    });

    resourcePrev.addEventListener('click', () => {
      const panel = activeResourcePanel();
      if (!panel) return;
      panel.scrollBy({ left: -resourceStep(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });

    resourceNext.addEventListener('click', () => {
      const panel = activeResourcePanel();
      if (!panel) return;
      panel.scrollBy({ left: resourceStep(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });

    window.addEventListener('resize', updateResourceControls);
    updateResourceControls();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-sy-resource-root]').forEach(initialize);

  boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
